import React from 'react';
import { useInput } from 'react-admin';
import { ServerConfigForm } from './ServerConfigForm';

interface ServerConfigInputProps {
    source: string;
    disabled?: boolean;
}

export const ServerConfigInput: React.FC<ServerConfigInputProps> = ({ source, disabled }) => {
    const {
        field,
    } = useInput({ source });

    // Note: Config initialization is now handled at the form level via transform function

    // Parse the config if it's a string
    const config = React.useMemo(() => {
        console.log('[ServerConfigInput] Raw field value:', field.value, typeof field.value);
        if (typeof field.value === 'string') {
            try {
                const parsed = JSON.parse(field.value);
                console.log('[ServerConfigInput] Parsed config from string:', parsed);
                return parsed;
            } catch {
                console.log('[ServerConfigInput] Failed to parse config string, using empty object');
                return {};
            }
        }
        const finalConfig = field.value || {};
        console.log('[ServerConfigInput] Final config object:', finalConfig);
        return finalConfig;
    }, [field.value]);

    const handleChange = (newConfig: any) => {
        console.log('[ServerConfigInput] Config changed:', newConfig);
        console.log('[ServerConfigInput] Sending to form:', newConfig);
        // Ensure we always send an object, never undefined
        field.onChange(newConfig || {});
    };

    return (
        <ServerConfigForm
            config={config}
            onChange={handleChange}
            disabled={disabled}
        />
    );
};